import { Controller } from "@hotwired/stimulus";
import React from "react";
import ReactDOM from "react-dom";
import Checkout from "../packs/payments/Checkout";

export default class extends Controller {
  static values = { props: String };

  connect() {
    const props = JSON.parse(this.propsValue);
    ReactDOM.render(<Checkout {...props} />, this.element);
  }
}
